import React from 'react';
import './App.css';
import './About.css'
import Navbar from './Navbar';

const About = () => (
    <div className="App">
        <header className="hero-section">
            <Navbar />
            <div className="about-section">
                <h2>About Me</h2>
                <img src={process.env.PUBLIC_URL + '/boun258.png'} alt="Boun" className="about-image" />
                <div class="blurb-container">

                    <p class="greeting">Hi! I'm Boun (pronounced "boon"). I'm a <strong>certified personal trainer</strong> dedicated to helping you achieve your fitness goals. Whether you're a beginner taking your first steps or a seasoned athlete, I offer personalized plans to fit your unique needs.</p>

                    <p class="specialization-focus">I specialize in designing safe, effective training programs for individuals managing <strong>previous or current injuries</strong>, focusing on smart, progressive movements to help you return to activity stronger than before.</p>

                    <h2 class="section-title">Specialized Training & Background</h2>

                    <p>My approach is rooted in my background as a <strong>Physical Therapy Assistant (PTA)</strong>, which gives me a unique specialization in training people with <strong>previous or current injuries</strong>. I'm passionate about helping clients not just get fit, but also <strong>move better, stronger, and pain-free</strong>.</p>

                    <p>This expertise also extends to <strong>sports-specific training</strong>, where I help athletes enhance performance, power, and agility.</p>

                    <h2 class="section-title">My Goals for My Clients</h2>

                    <p>Having spent years as a personal trainer, I believe fitness should be effective, sustainable, and enjoyable. My primary goal for my clients is to empower them to:</p>

                    <ul class="goals-list">
                        <li>Build <strong>long-term healthy habits</strong>.</li>
                        <li>Achieve <strong>meaningful strength and endurance improvements</strong>.</li>
                        <li>Gain the <strong>confidence</strong> that comes from feeling their best—all while training in a safe, judgment-free environment.</li>
                    </ul>

                    <h2 class="section-title">A Little About Me</h2>

                    <p>When I'm not in the gym, you can find me fueling my other passions! I'm an enthusiast for <strong>cars</strong> (especially classic models), and you might catch me listening to a lot of <strong>Taylor Swift</strong> while reviewing new <strong>movies</strong> I've seen over the weekend.</p>

                </div>
            </div>
        </header>
        <footer className="footer">
            <p>&copy; {new Date().getFullYear()} Boun Health & Performance</p>
        </footer>
    </div>


);

export default About;
